export enum HistoryEventKindEnum {
    Creation = 'creation',
    Update = 'update',
    Deletion = 'deletion',
    Restoration = 'restoration',
    StatusSet = 'statusSet',
    StatusRemoved = 'statusRemoved',
}
